import AuthStore from 'auth-store';
import ModuleWrapper, {
  ModuleRoute,
  ModuleLabel,
} from 'partial/wrappers/ModuleWrapper';
import React, { useState } from 'react';
import Sidebar from 'partial/components/Sidebar';
import Profile from 'partial/containers/Profile';
import Logout from 'modules/auth/containers/Logout';
import { ModalProvider } from 'partial/components/Modal';
import PageWrapper from 'partial/components/PageWrapper';
import { Switch, Route, Redirect } from 'react-router-dom';
import PageNotFound from 'partial/containers/PageNotFound';
import HeaderProfile from 'partial/components/HeaderProfile';
import { HiOutlineBell, HiOutlineMenuAlt2 } from 'react-icons/hi';
import UserRoutes from 'core-modules/users/containers/UserRoutes';
import ChannelRoutes from 'core-modules/channels/containers/ChannelRoutes';
import CategoryDiagram from 'core-modules/category/container/CategoryDiagram';
import MerchantRoutes from 'core-modules/merchants/containers/MerchantRoutes';
import DashboardRoutes from 'core-modules/dashboard/containers/DashboardRoutes';
import DeveloperRoutes from 'core-modules/developers/containers/DeveloperRoutes';
import SettlementRoutes from 'core-modules/merchants/containers/SettlementRoutes';
import DashboardTransactions from 'core-modules/dashboard/containers/DashboardTransactions';

import SettingRoutes from 'core-modules/settings/containers/SettingRoutes';
// import AccountMode, {
// import { AccountModeAlert } from 'core-modules/profile/components/AccountMode';
import ProfileWrapper from 'modules/auth/containers/ProfileWrapper';
import MyAccountWrapper from 'modules/auth/containers/MyAccountWrapper';
import InvoiceRoutes from 'core-modules/invoice/containers/InvoiceRoutes';
import ReportsContainer from 'core-modules/reports/containers/ReportsContainer';
// import OnboardingRoutes from 'core-modules/merchant-onboarding/containers/OnboardingRoutes';
import ProfileCard from 'core-modules/profile/containers/ProfileCard';

const SHOW_NOTIFICATIONS = false;

function Private() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const userRole = AuthStore.get('_role');

  return (
    <ProfileWrapper>
      <MyAccountWrapper>
        <ModuleWrapper>
          <ModalProvider>
            <div className="h-screen flex overflow-hidden bg-gray-100">
              <Sidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
              />
              <div className="flex flex-col w-0 flex-1 overflow-hidden">
                <div className="relative z-20 flex-shrink-0 flex h-24 bg-white md:bg-transparent">
                  <button
                    className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500 md:hidden"
                    onClick={() => setSidebarOpen(true)}
                    type="button"
                  >
                    <span className="sr-only">Open sidebar</span>
                    <HiOutlineMenuAlt2 className="h-6 w-6" aria-hidden="true" />
                  </button>
                  <div className="flex-1 px-8 flex justify-between">
                    <div className="flex-1 flex items-center relative">
                      <div className="absolute w-full line-clamp-1">
                        <h1 className="text-2xl font-semibold text-gray-900 truncate">
                          <ModuleLabel />
                        </h1>
                      </div>
                    </div>
                    <div className="ml-4 flex items-center md:ml-6 space-x-6">
                      {/* <AccountMode /> */}
                      {SHOW_NOTIFICATIONS ? (
                        <button
                          className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                          type="button"
                        >
                          <span className="sr-only">View notifications</span>
                          <HiOutlineBell
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        </button>
                      ) : null}
                      {/* Profile dropdown */}
                      <HeaderProfile />
                    </div>
                  </div>
                </div>

                <main className="flex-1 relative overflow-y-auto focus:outline-none flex flex-col z-10">
                  {/* <AccountModeAlert /> */}
                  <Switch>
                    <Route path="/logout" component={Logout} />
                    <ModuleRoute
                      title="Dashboard"
                      path="/dashboard"
                      component={DashboardRoutes}
                    />
                    <ModuleRoute
                      title="Developers"
                      path="/developers"
                      component={DeveloperRoutes}
                    />
                    <ModuleRoute
                      title="Transactions"
                      path="/transactions"
                      component={DashboardTransactions}
                    />
                    <ModuleRoute
                      title="Billers"
                      path="/billers"
                      component={MerchantRoutes}
                    />
                    <ModuleRoute
                      title="Settlements"
                      path="/settlement"
                      component={SettlementRoutes}
                    />
                    <ModuleRoute title="Invoice" path="/invoice">
                      <PageWrapper>
                        <InvoiceRoutes />
                      </PageWrapper>
                    </ModuleRoute>
                    <ModuleRoute title="Reports" path="/report">
                      <PageWrapper>
                        <ReportsContainer />
                      </PageWrapper>
                    </ModuleRoute>
                    <ModuleRoute
                      title="Channel"
                      path="/channels"
                      component={ChannelRoutes}
                    />
                    <ModuleRoute
                      title="Categories"
                      path="/categories"
                      component={CategoryDiagram}
                    />
                    <ModuleRoute
                      title="Settings"
                      path="/settings"
                      component={SettingRoutes}
                    />
                    {userRole === 'organization' ? (
                      <ModuleRoute
                        title="Access Control"
                        path="/acl"
                        component={UserRoutes}
                      />
                    ) : null}
                    <ModuleRoute
                      title="Profile"
                      path="/profile"
                      component={Profile}
                    />
                    {/* <ModuleRoute
                      title="Complete Profile"
                      path="/onboarding"
                      component={OnboardingRoutes}
                    /> */}
                    <ModuleRoute
                      title="My Profile"
                      path="/my-profile"
                      component={() => (
                        <PageWrapper>
                          <ProfileCard />
                        </PageWrapper>
                      )}
                    />
                    <Route exact path="/">
                      <Redirect to="/dashboard" />
                    </Route>
                    <Route component={PageNotFound} />
                  </Switch>
                </main>
              </div>
            </div>
          </ModalProvider>
        </ModuleWrapper>
      </MyAccountWrapper>
    </ProfileWrapper>
  );
}

export default Private;
